module.exports = __webpack_public_path__ + "img/20200513_151114.b06a1a9d.jpg";